var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemecoinBgShape1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 923",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1800.56 891.349C1860.6 891.349 1860.03 922.5 1920 922.5V0H0V922.5C59.9603 922.5 60.5579 891.349 120.518 891.349C180.48 891.349 180.561 922.5 240.522 922.5C300.483 922.5 300.565 891.349 360.525 891.349C420.486 891.349 420.567 922.5 480.528 922.5C540.488 922.5 540.57 891.349 600.531 891.349C660.492 891.349 660.492 922.5 720.535 922.5C780.577 922.5 780.495 891.349 840.538 891.349C900.583 891.349 900.497 922.5 960.543 922.5C1020.58 922.5 1020.5 891.349 1080.54 891.349C1140.59 891.349 1140.51 922.5 1200.55 922.5C1260.59 922.5 1260.51 891.349 1320.55 891.349C1380.59 891.349 1380.51 922.5 1440.56 922.5C1500.59 922.5 1500.52 891.349 1560.55 891.349C1620.6 891.349 1620.51 922.5 1680.56 922.5C1740.6 922.5 1740.52 891.349 1800.56 891.349Z",
    fill: "url(#paint0_linear_1636_8004)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1636_8004",
    x1: 960,
    y1: -361,
    x2: 960,
    y2: 922.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9462"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemecoinBgShape1);
export default __webpack_public_path__ + "static/media/memecoin_bg_shape_1.593e3758f3786f7eba23dde460516e03.svg";
export { ForwardRef as ReactComponent };